<script setup lang="ts">
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import VInput from '@shared/form/VInput/VInput.vue';
import { toTypedSchema } from '@vee-validate/zod';
import { useField } from 'vee-validate';
import { inject, ref } from 'vue';
import { z } from 'zod';
import { isDisabledInjectionKey, isReadonlyInjectionKey } from '../keys';

const props = defineProps<{
  fieldId: string;
  label: string;
  propertyName: string;
  tooltip: string;
}>();

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });
const maxLength = 63;
const emailSchema = z
  .union([z.string().email().max(maxLength), z.string().max(0).nullable()])
  .or(z.literal(null))
  .or(z.literal(undefined));
const { errors, value } = useField(props.propertyName, toTypedSchema(emailSchema));
const fieldId = `relatiegegevens-${props.fieldId}`;
</script>

<template>
  <FieldRowV2 :errors :label="props.label" :label-for="fieldId" :tooltip="props.tooltip ?? ''">
    <VInput
      v-if="!hasReadonlyParent"
      v-model="value"
      :has-error="!!errors.length"
      :id="fieldId"
      :is-disabled="hasDisabledParent"
      type="email"
      :max-length="maxLength"
    />
    <div v-else>
      {{ value ?? '-' }}
    </div>
  </FieldRowV2>
</template>
